import { Component, OnInit, ViewChild } from "@angular/core";
import { Remuneration } from "./executive-remuneration.model";
import { ApiService } from "@shared/services/api.service";
import { Urls } from "@utils/urls";
import { ToastrService } from "ngx-toastr";
import { NgForm } from "@angular/forms";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { RemunerationDialogComponent } from "@component/key-policies/statuory/remuneration-dialog/remuneration-dialog.component";

@Component({
  selector: "app-executive-remuneration",
  templateUrl: "./executive-remuneration.component.html",
  styleUrls: ["./executive-remuneration.component.scss"],
})
export class ExecutiveRemunerationComponent implements OnInit {
  @ViewChild("f", { static: false }) form: NgForm;

  foloioNo: number;
  filteredData: Array<Object> = null
  bankAccountNo: string;

  primaryPanNumber: string;

  termsAndCondition: false;

  constructor(
    public apiService: ApiService,
    private toastr: ToastrService,
    public dialog: MatDialog
  ) { }

  ngOnInit() { }

  public submitRemuneration() {
    const obj: Remuneration = {
      pan: this.primaryPanNumber,
      folioNo: `${this.foloioNo}`,
      bankAccountNo: this.bankAccountNo,
    };

    this.apiService.postData(Urls.addStatutory, obj).subscribe(
      (response) => {
        if (response.status === 0) {
          const data = response.data;
          if (data) {
            this.filteredData = data.files
            // window.open(data.url, "_blank");
            // this.filteredData.push({
            //   url: data.url,
            //   fileName: data.fileName
            // })
            this.resetForm();
          }
        } else {
          const dialogRef = this.dialog.open(RemunerationDialogComponent, {
            width: "350px",
            data: "Provided Investor details is incorrect. Please retry with valid details"
          });
          dialogRef.afterClosed().subscribe((result) => {
            if (result === true) {
              this.resetForm();
            }
          });
          // this.filteredData = [{
          //   url: "Test",
          //   fileName: "Test File"
          // }, {
          //   url: "Test",
          //   fileName: "Test File"
          // }, {
          //   url: "Test",
          //   fileName: "Test File"
          // }]
        }
      },
      (error) => {
        if (error.status === -1) {
          const dialogRef = this.dialog.open(RemunerationDialogComponent, {
            width: "350px",
            data: "Provided Investor details is incorrect. Please retry with valid details"
          });
          dialogRef.afterClosed().subscribe((result) => {
            if (result === true) {
              this.resetForm();
            }
          });
          // this.filteredData = [{
          //   url: 'http://65.1.66.65:9009/admin/pdf/1618590580-1604409965-Notice_cum_Addendum_Additional_Official_Points_of_Acceptance_-_19_05_2020.pdf',
          //   fileName: "Test File"
          // }, {
          //   url: 'http://65.1.66.65:9009/admin/pdf/1618590580-1604409965-Notice_cum_Addendum_Additional_Official_Points_of_Acceptance_-_19_05_2020.pdf',
          //   fileName: "Test File"
          // }, {
          //   url: 'http://65.1.66.65:9009/admin/pdf/1618590580-1604409965-Notice_cum_Addendum_Additional_Official_Points_of_Acceptance_-_19_05_2020.pdf',
          //   fileName: "Test File"
          // }, {
          //   url: 'http://65.1.66.65:9009/admin/pdf/1618590580-1604409965-Notice_cum_Addendum_Additional_Official_Points_of_Acceptance_-_19_05_2020.pdf',
          //   fileName: "Test File"
          // }, {
          //   url: 'http://65.1.66.65:9009/admin/pdf/1618590580-1604409965-Notice_cum_Addendum_Additional_Official_Points_of_Acceptance_-_19_05_2020.pdf',
          //   fileName: "Test File"
          // }, {
          //   url: 'http://65.1.66.65:9009/admin/pdf/1618590580-1604409965-Notice_cum_Addendum_Additional_Official_Points_of_Acceptance_-_19_05_2020.pdf',
          //   fileName: "Test File"
          // }]
        }
      }
    );
  }

  viewFile = (path) => {
    window.open(path, '_blank');
  }

  public resetForm() {
    if (this.form) {
      this.form.resetForm();
    }
  }
}
